module.exports = __webpack_public_path__ + "img/wesley_snipes.6119e2df.jpg";